import { InjectionKey } from 'vue'

export const schemaPropertyObjectDepthSymbol: InjectionKey<number> = Symbol()